<!-- 电能耗 -->
<template>
  <div class="ele">
    <div class="returnScence" @click="returnScence"></div>
    <!-- <div
      class="returnScence2"
      @click="returnScence2"
      v-show="isShowParkingNormal"
    ></div> -->
    <div class="left-ele-content">
      <div class="top-ele">
        <custom-dayPlane
          :title="`电能耗(${areaNum2[eleNum]})`"
          :iconImg="require('@/assets/consump/ele.png')"
          @changeDay="changeDay"
        >
          <div class="water-content">
            <div class="left-content">
              <div class="top-num">
                <div class="num">{{ getTimeValue(getEleNum) }}</div>
              </div>
              <div class="bot-name">{{ map[timeValue] }}总量(kWh)</div>
            </div>
            <div class="right-chart">
              <custom-charts
                :dataList="dataList"
                :timer="timeValue"
              ></custom-charts>
            </div>
          </div>
        </custom-dayPlane>
      </div>
      <div class="bot-ele">
        <custom-table
          :areaNum="eleNum"
          :isLoadEnd="isLoadEnd"
          :header="header"
          :tableData="tableData"
          ref="eleCons"
        ></custom-table>
      </div>
    </div>
    <div class="right-content">
      <ele-meter
        ref="childEle"
        :meterEleData="meterEleData"
        v-if="isEleMeter"
        @closeDialog="closeDialog"
      ></ele-meter>
    </div>
  </div>
</template>

<script>
import bus from "@/components/three-scene/Bus.js";
import EleMeter from "./components/ele-meter.vue";
import {
  getElectricityEnergyData,
  getEqpInfo,
  getElectricityEnergyDataByArea,
} from "@/api/index.js";
export default {
  data() {
    return {
      isShowParkingNormal: false,
      isLoadEnd: false,
      eleData: {},
      isShowReturn: false,
      meterEleData: {}, //电表
      isEleMeter: false,
      eleAreaData: {},
      header: [
        {
          name: "区号",
          key: "buildNo",
          width: "48",
          flag: 0,
        },
        {
          name: "楼层",
          key: "floor",
          width: "40",
          flag: 0,
        },
        {
          name: "设备名",
          key: "eqpName",
          width: "100",
          flag: 0,
        },
        {
          name: "日能耗",
          unit: "(kWh)",
          key: "energyDay",
          width: "94",
          isUp: 0,
          flag: 1,
        },
        {
          name: "月能耗",
          unit: "(kWh)",
          key: "energyMonth",
          width: "94",
          isUp: 0,
          flag: 1,
        },
      ],
      tableData: [],
      eleNum: "总",
      areaNum2: {
        A区地下室: "A",
        B区地下室: "B",
        C区地下室: "C",
        D区地下室: "D",
        人防区地下室: "人防",
        总: "总",
        A1: "A1",
        A2: "A2",
        B1B2: "B1B2",
        B3: "B3",
      },
      timeValue: "day",
      map: {
        day: "当日",
        month: "当月",
        year: "当年",
      },
      buildMap: {
        总: "total",
        B3: "04",
        B1B2: "03",
        A2: "02",
        A1: "01",
        A区地下室: "A",
        B区地下室: "B",
        C区地下室: "C",
        D区地下室: "D",
        人防区地下室: "人防",
      },
      dayMap: {
        day: "historicalDay",
        month: "historicalMonth",
        year: "historicalYear",
      },
      indexMap: {
        day: [10, 13],
        month: [8, 11],
        year: [5, 8],
      },
      timer: null,
    };
  },
  mounted() {
    this.$store.state.threeEvent.intoEleCon = true;
    bus.on("setName", this.getBuild);
    bus.emit("openFloorLabel", true);
    bus.emit("showFloorPoint", "电表", true);
    bus.on("dialogNumber", this.showDialogContainer);
    bus.on("parkingArea2", this.clickParking);
  },
  components: {
    EleMeter,
  },
  created() {
    this.getEnergyWater();
    this.getElectricityByArea();
    this.timer = setInterval(() => {
      // this.getEnergyWater();
      this.getElectricityByArea();
    }, 30*60*1000);
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  },
  watch: {
    meterEleData() {
      this.$nextTick(() => {
        if (this.$refs.childEle) {
          this.$refs.childEle.dataBtn = "用电量";
        }
      });
    },
  },
  computed: {
    getEleNum() {
      if (this.eleAreaData[this.buildMap[this.eleNum]]) {
        return this.eleAreaData[this.buildMap[this.eleNum]][this.timeValue];
      }
    },
    dataList() {
      if (
        this.eleAreaData?.[this.buildMap[this.eleNum]]?.[
          this.dayMap[this.timeValue]
        ]
      ) {
        return this.loadData(
          this.eleAreaData[this.buildMap[this.eleNum]][
            this.dayMap[this.timeValue]
          ],
          this.indexMap[this.timeValue][0],
          this.indexMap[this.timeValue][1]
        );
      }

      return { x: [], y: [] };
    },
  },
  methods: {
    //改变监测的设备
    clickParking() {
      this.isShowParkingNormal = true;
    },
    returnScence2() {
      bus.emit("parking-mr");
      this.isShowParkingNormal = false;
    },
    async showDialogContainer(eqpCode) {
      let { data: res } = await getEqpInfo({ eqpCode });
      this.meterEleData = res;
      this.isEleMeter = true;
      this.isShowDialog = true;
    },
    getBuild(buildName) {
      this.eleNum = buildName;
      this.isShowReturn = true;
    },
    returnScence() {
      bus.emit("back");
      this.eleNum = "总";
      this.$refs.eleCons.selectIndex = null;
      if (this.isShowDialog) {
        this.closeDialog();
      }
    },
    getTimeValue(value) {
      if (!value && value != 0) {
        value = "-";
      }
      return value;
    },
    async getEnergyWater() {
      let { data: res } = await getElectricityEnergyData();
      // this.eleData = res.electricity;
      this.tableData = res;
      this.isLoadEnd = true;
    },
    async getElectricityByArea() {
      let { data: res } = await getElectricityEnergyDataByArea();
      this.eleAreaData = res;
    },
    loadData(value, first, end) {
      let resData = { x: [], y: [] };
      value.map((item, index) => {
        let [res] = Object.entries(item);
        resData.x.push(res[0].slice(first, end));
        resData.y.push(res[1]);
      });
      return resData;
    },
    changeDay(value) {
      this.timeValue = value;
      this.loadData(
        this.eleAreaData[this.buildMap[this.eleNum]][
          this.dayMap[this.timeValue]
        ],
        this.indexMap[this.timeValue][0],
        this.indexMap[this.timeValue][1]
      );
    },
    // 弹框关闭
    closeDialog() {
      this.isShowDialog = false;
      this.isEleMeter = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.returnScence {
  position: absolute;
  width: 144px;
  height: 56px;
  left: 536px;
  top: 135px;
  cursor: pointer;
  background-image: url("../../../../../../assets/pagesImg/returnBtn-normal.png");
  &:hover {
    background-image: url("../../../../../../assets/pagesImg/returnBtn-active.png");
  }
}
.returnScence2 {
  position: absolute;
  width: 144px;
  height: 56px;
  left: 536px;
  top: 213px;
  cursor: pointer;
  background-image: url("../../../../../../assets/pagesImg/returnBtn-normal.png");

  &:hover {
    background-image: url("../../../../../../assets/pagesImg/returnBtn-active.png");
  }
}
.left-ele-content {
  position: absolute;
  left: 107px;
  top: 135px;
  width: 416px;
  .top-ele {
    width: 100%;
    height: 178px;
    .water-content {
      position: relative;
      display: flex;
      margin: 20px;
      .left-content {
        width: 156px;
        height: 92px;
        .top-num {
          display: flex;
          width: 156px;
          height: 55px;
          align-items: baseline;
          .num {
            font-weight: 500;
            font-size: 48px;
            line-height: 55px;
            // width: 74px;
            color: #2d82ff;
            font-family: "dina";
          }
          .unit {
            // position: absolute;
            // top: -47px;
            // left: 113px;
            margin-left: 4px;
            font-weight: 500;
            font-size: 20px;
            line-height: 23px;
            color: rgba(255, 255, 255, 0.8);
            font-family: "dina";
          }
        }
        .bot-name {
          margin-top: 10px;
          font-weight: 500;
          font-size: 18px;
          line-height: 27px;
          color: #fff;
        }
      }
      .right-chart {
        margin-left: 20px;
        width: 200px;
        height: 91px;
      }
    }
  }
  .bot-ele {
    height: 678px;
    margin-top: 20px;
  }
}
.right-content {
  position: absolute;
  top: 135px;
  right: 43px;
  width: 416px;
  height: 272px;
}
</style>
